import { ParameterData } from '@/core/types'
import { classifyTypeUsage } from '@/core/utils/mappers/formatTypeUsage'

import { getNestedElementDisplay } from './arrayBrackets'
import { type CodeSign } from './codeSigns'
import { tryParseArrayInput } from './parseArrayInput'
import { renderArrayLiteral, renderPrimitiveLiteral } from './renderLiteral'

export function formatParameterLiteral(
  rawValue: string | number,
  param: ParameterData,
  technology: string,
  signs: CodeSign
): string {
  const shape = classifyTypeUsage(param.typeUsage)

  if (shape.kind === 'array') {
    const items = typeof rawValue === 'string' ? tryParseArrayInput(rawValue) : null
    if (items === null) return String(rawValue)
    const elementDisplay = getNestedElementDisplay(shape, technology)
    return renderArrayLiteral(items, shape, technology, signs, elementDisplay)
  }

  if (shape.kind === 'primitive') {
    return renderPrimitiveLiteral(rawValue, shape.primitiveType, technology, signs)
  }

  if (param.type === 'System.String') {
    return `${signs.stringSign}${rawValue}${signs.stringSign}`
  }

  return String(rawValue)
}
